/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WatchListsFilter = {
    /**
     * Number of results to return.
     */
    limit?: number;
    /**
     * Which field to use when ordering the results. Available fields: `id`, `created_date`, `modified_date`
     */
    ordering?: string;
}
export const EmptyWatchListsFilter: WatchListsFilter = {
    limit: 20,
    ordering: undefined,
}